import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clientChecklistKeyMaker } from "../../Entity/hooks/useClientChecklist";
import { clientChecklistKeyMakerV2 } from "../../Entity/hooks/useClientChecklistV2";
import { keyMaker } from "../../Entity/hooks/useClientProfile";
import { delayFor } from "../../utils/delayFor";
import putSignAgreement from "../requests/putUpdateAgreement";
import { docCenterGetAgreementsKeyMaker } from "./useGetAgreements";
export default function usePutSignAgreement(clientId, config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (input) => {
            if (config === null) {
                throw new Error("no auth");
            }
            await putSignAgreement(input.agreementId, input.status, config);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: docCenterGetAgreementsKeyMaker(),
            });
            if (clientId !== null) {
                queryClient.invalidateQueries({
                    queryKey: keyMaker(clientId),
                });
                delayFor([0, 5, 10, 30], () => {
                    queryClient.invalidateQueries({
                        queryKey: clientChecklistKeyMaker(clientId),
                    });
                    queryClient.invalidateQueries({
                        queryKey: clientChecklistKeyMakerV2(clientId),
                    });
                });
            }
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePutUpdateAgreement.js.map